/* Sticky koopbalk (mobiel): toont de balk zodra de gewone koopknop uit beeld
   is gescrold en houdt label, disabled-status en prijs gelijk aan het
   hoofdformulier. Hoort bij snippets/samzwam-sticky-buy.liquid. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.samzwam-sticky-buy');
    if (!bar) return;
    var sectionId = bar.getAttribute('data-section-id');
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainButton) return;

    var barButton = bar.querySelector('[data-sticky-submit]');
    var barPrice = bar.querySelector('[data-sticky-price]');
    var priceBox = document.getElementById('price-' + sectionId);

    function syncButton() {
      if (!barButton) return;
      var span = mainButton.querySelector('span');
      var label = (span ? span.textContent : mainButton.textContent).trim();
      if (label) barButton.textContent = label;
      barButton.disabled = mainButton.disabled;
    }

    function syncPrice() {
      if (!barPrice || !priceBox) return;
      var el =
        priceBox.querySelector('.price--on-sale .price__sale .price-item--sale') ||
        priceBox.querySelector('.price__regular .price-item--regular') ||
        priceBox.querySelector('.price-item');
      if (el) barPrice.textContent = el.textContent.trim();
    }

    syncButton();
    syncPrice();

    var observer = new MutationObserver(function () {
      syncButton();
      syncPrice();
    });
    observer.observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceBox) observer.observe(priceBox, { childList: true, subtree: true, characterData: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.hidden = !passed;
        },
        { threshold: 0 }
      );
      io.observe(mainButton);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
